import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'brightside-web-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit, OnDestroy {
  _bodyEl = document.getElementsByTagName('body')[0];
  registrationPage: boolean;

  constructor(private title: Title) {
    this._bodyEl.classList.add('brightside', 'not-logged-in');
    this.registrationPage = window.location.pathname.includes('registration/create-account');
  }

  ngOnInit() {
    this.title.setTitle('Brightside | Onboarding');
  }

  ngOnDestroy(): void {
    this._bodyEl.classList.remove('brightside', 'not-logged-in');
  }
}
